import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import functions from '../firebase/functions';
import { useAuth } from '../auth/useAuth';
import { shouldTrack, externalReferrer } from '../utils/pageView';

// Website-Statistik (v3.148.0): meldet jeden Seitenwechsel an trackPageView —
// auch ohne Login. Haengt als element an der pathless Wurzelroute in App.js und
// sieht damit jeden Routenwechsel.
//
// Bewusst OHNE sessionStorage/localStorage/Cookies: Ob der Einstieg schon gemeldet
// wurde, merkt sich eine Modulvariable — nichts wird auf dem Endgeraet gespeichert.
let entryReported = false;

const trackPageView = httpsCallable(functions, 'trackPageView');

export default function PageViewTracker() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const lastPathRef = useRef(null);

  useEffect(() => {
    // Erst melden, wenn der Login-Status feststeht — sonst zaehlte der erste Aufruf
    // eines angemeldeten Nutzers als anonym.
    if (loading) return;
    if (lastPathRef.current === pathname) return; // StrictMode-Doppeleffekt
    lastPathRef.current = pathname;

    const { hostname, host } = window.location;
    if (!shouldTrack({
      pathname,
      hostname,
      nav: navigator,
      useEmulators: process.env.REACT_APP_USE_EMULATORS === 'true',
    })) return;

    const entry = !entryReported;
    entryReported = true;
    trackPageView({
      path:     pathname,
      entry,
      referrer: entry ? externalReferrer(document.referrer, host) : '',
      signedIn: !!user,
    }).catch(() => {});
    // user bewusst nicht in den Deps: ein Login soll keinen zweiten Aufruf zaehlen.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, loading]);

  return <Outlet />;
}
